import React from 'react';

import AuthHeader from '../AuthHeader';
import AuthFooter from '../AuthFooter';

import { Container, Content, ContentVariant } from './styles';

type AuthLayoutProps = {
  children: React.ReactNode;
  // eslint-disable-next-line react/require-default-props
  variant?: ContentVariant;
};

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  variant = 'login',
}) => {
  return (
    <Container>
      <AuthHeader />
      <Content variant={variant}>{children}</Content>
      <AuthFooter />
    </Container>
  );
};

export default AuthLayout;
